import { AppGrid } from './components';
import { useLanguageStore } from '../../store/languageStore';
import { getTranslation } from '../../i18n/translations';

export const AppLauncherPage = () => {
  const { language } = useLanguageStore();
  const t = getTranslation(language);

  return (
    <div className="container mx-auto px-4 py-12">
      {/* Hero Section */}
      <section className="mb-16 text-center">
        <h1 className="mb-4 text-5xl font-bold md:text-6xl lg:text-7xl">
          <span className="bg-gradient-to-r from-primary via-purple-500 to-pink-500 bg-clip-text text-transparent">
            {t.apps.hero.title}
          </span>
        </h1>
        <p className="mx-auto max-w-2xl text-lg text-muted-foreground md:text-xl">
          {t.apps.hero.tagline}
        </p>
      </section>

      {/* Apps Section */}
      <section>
        
        <AppGrid />
      </section>
    </div>
  );
};
